var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 225,
    height: 244,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "",
    clipRule: "evenodd",
    transform: "matrix(1 0 0 1 0 0)",
    d: "M0 183L0 0L0 0L169.5 0L169.5 0L169.5 183L169.5 183L0 183z"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(0.757764 -0 0 0.757764 0.35403982 4.925461)",
    id: 175,
    x: 0,
    y: 0,
    width: 121,
    height: 208,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 121,
    height: 208,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAADQCAYAAAAj6c5vAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAB4SURBVHhe7cEBAQAAAIIg/69uSEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcK8Gih8AAaVEHikAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(0.757764 -0 0 0.757764 52.07143 0.37887573)",
    id: 742,
    x: 0,
    y: 0,
    width: 154,
    height: 241,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 154,
    height: 241,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAADxCAYAAAAzzK6OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAACnSURBVHhe7cExAQAAAMKg9U9tCj8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAjxpE9wABplNFFwAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 1.3333 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 183)",
    d: "M0.35403982 162.54037L0.35403982 162.54037L0.35403982 162.54037L92.00294 162.54037L92.00294 162.54037L92.00294 162.54037L92.00294 162.54037L92.00294 4.546585L92.00294 4.546585L92.00294 4.546585L92.00294 4.546585L0.35403982 4.546585z",
    stroke: "none",
    fill: "url(#175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "",
    transform: "matrix(1 0 0 -1 0 183)",
    d: "M52.07143 183L52.07143 183L52.07143 183L168.70154 183L168.70154 183L168.70154 183L168.70154 183L168.70154 0.45692444L168.70154 0.45692444L168.70154 0.45692444L168.70154 0.45692444L52.07143 0.45692444z",
    stroke: "none",
    fill: "url(#742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumKids);
export default __webpack_public_path__ + "static/media/PremiumKids.b12d5fe87fbcbdabdf256fb6bbc910ff.svg";
export { ForwardRef as ReactComponent };